angular.module('unica_event_field.event_field_controllers')

.controller('EventFieldCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	EventFieldCreateService, EventFieldListService
) {

	$scope.eventFieldList = [];

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadEventFieldLists = function()
	{
		$scope.showLoader();

		EventFieldListService
			.list( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.eventFieldList = $scope.eventFieldList.concat( data );
				}
			});
	};

	$scope.loadEventFieldLists();

	$rootScope.eventFieldData = {
		event_id: $stateParams.event_id,
		format_filename: '{{ Codice Fiscale }}',
		show_in_summary: true,
		options: [],
		conditions: []
	};

	$scope.resetFilename = function() {
		$rootScope.eventFieldData.format_filename = '';
		$scope.disableFiscalCode = false;
		$scope.disableNet = false;
		$scope.disableAgencyCode = false;
	}


	$scope.disableFiscalCode = true;
	$scope.disableNet = false;
	$scope.disableAgencyCode = false;

	$scope.saveEventField = function()
	{
		var eventFieldData = angular.copy($rootScope.eventFieldData);

		if ( eventFieldData.format_filename && !eventFieldData.format_filename.includes('{{ Codice Fiscale }}') ) {
			$rootScope.showErrorMsg('Il codice fiscale è obbligatorio nel Formato Nome');
			return;
		}

		eventFieldData.name = $scope.parseFieldName( eventFieldData.name );

		if ( eventFieldData.type === 'label' ) {
			eventFieldData.show_in_summary = 0;
		}

		if ( eventFieldData.type !== 'select' ) {
			eventFieldData.options = null;
		} else if ( eventFieldData.options.length === 0 ) {
			$rootScope.showErrorMsg('La tipologia select necessita la definizione di almeno un\'opzione');
			return;
		} else {
			angular.forEach(eventFieldData.options, function(opt, key) {
				eventFieldData.options[key].name = $scope.parseFieldName( opt.name );
			});
		}

		// console.log(eventFieldData); return;

		$scope.showLoader();
		EventFieldCreateService
			.create( eventFieldData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Field aggiunto con successo!', '');

					$state.go('app.event_field.list', { event_id: $stateParams.event_id });
				}
			});
	};

});

